import React, { useState, useEffect, Fragment } from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import Select from "react-select";
import { ReactComponent as ArrowRight } from "../../../../../assets/icons/ArrowRight.svg";
import { ReactComponent as SearchIcon } from "../../../../../assets/icons/Search.svg";
import { ReactComponent as ClearCrossIcon } from "../../../../../assets/icons/ClearCross.svg";
import { ReactComponent as SortArrowIcon } from "../../../../../assets/icons/SortArrow.svg";
import { DefaultColumnFilter } from "./filters";
import { dateFilters } from "../../../../../constants/constants";
const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  const [value, setValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div
      className="d-flex"
      style={{
        gap: "10px",
        width: "fit-content",
        borderBottom: "1px solid lightgray",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SearchIcon />
      <div
        className="d-flex"
        style={{ gap: "5px", justifyContent: "center", alignItems: "center" }}
      >
        <input
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          placeholder={`Search by Diagnosis / Notes `}
          style={{
            border: "none",

            borderRadius: "0px",
            backgroundColor: "transparent",
            width: "15rem",
          }}
        />
        <ClearCrossIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            setValue("");
            setGlobalFilter("");
          }}
        />
      </div>
    </div>
  );
};

// const DateFilter = ({ handleSelect }) => {
//   return (
//     <div className="date-filter-container">
//       <span>Filter by date</span>
//       <Select
//         styles={{
//           control: (baseStyles) => ({
//             ...baseStyles,
//             padding: "0px",
//             backgroundColor: "transparent",
//             width: "10rem",
//             border: "0px",
//             outline: "0px",
//             color: "#94A3B8 !important",
//           }),
//         }}
//         components={{
//           IndicatorSeparator: () => null,
//         }}
//         placeholder="Select"
//         classNamePrefix="select"
//         name="date-filter"
//         options={dateFilters}
//         defaultValue={dateFilters[5]}
//         onChange={(e) => {
//           handleSelect(e);
//         }}
//       />
//     </div>
//   );
// };
const TableContainer = ({
  columns,
  data,
  renderRowSubComponent,
  notesFilterValue,
  startDate,
  endDate
}) => {
  const [pageList, setPageList] = useState([]);
  const [filter, setFilter] = useState(dateFilters[5]);
  const [filteredData, setFilteredData] = useState(data);

  function setDataType() {
    switch (notesFilterValue?.value) {
      case "My Personal Notes":
        return data.filter((item) => {
          if (item?.diagnosis === "Self Added Note") {
            return item;
          }
        });
      case "Patient BHI Notes":
        return data.filter((item) => {
          if (item?.diagnosis !== "Self Added Note") {
            return item;
          }
        });
      default:
        return data;
    }
  }

  useEffect(() => {
    setFilteredData(setDataType());
  }, [notesFilterValue,data]);


  // useEffect(() => {  
  //   let start_date = new Date(startDate);
  //   let end_date = new Date(endDate);
  
  //   const filteredData = data.filter(item => {
  //     const createdDate = new Date(item.created);
  //     return (
  //       createdDate >= start_date && createdDate <= end_date 
  //     );
  //   });
  //   if (filteredData.length > 0) {
  //     setFilteredData(filteredData);
  //   } else {
  //     setFilteredData([]);
  //   }
  // }, [startDate, endDate]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    visibleColumns,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    preGlobalFilteredRows,
    rows,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data: filteredData,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        sortBy: [
          {
            id: "created",
            aesc: true,
          },
        ],
        pageIndex: 0,
        pageSize: 10,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        <SortArrowIcon
          style={{ transform: "rotate(180deg)", marginLeft: "5px" }}
        />
      ) : (
        <SortArrowIcon style={{ marginLeft: "5px" }} />
      )
    ) : (
      ""
    );
  };
  useEffect(() => {
    let tempPages = [];
    for (let i = pageIndex; i < pageCount; i++) {
      tempPages.push(i + 1);
    }
    setPageList(tempPages);
  }, []);

  return (
    <Fragment>
      <div className="d-flex justify-content-between my-3">
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
        <></>
        {/* <DateFilter handleSelect={setFilter} /> */}
      </div>
      <table className="table my-3 px-2" {...getTableProps()}>
        <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="py-3"
              style={{
                height: "4rem",
                verticalAlign: "middle",
              }}
            >
              {headerGroup.headers.map((column) => (
                <th scope="col" {...column.getHeaderProps()}>
                  <div {...column.getSortByToggleProps()}>
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <Fragment key={row.getRowProps().key}>
                <tr
                  className="py-3"
                  style={{
                    height: "4rem",
                    verticalAlign: "middle",
                  }}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
                {row.isExpanded && (
                  <tr
                    className="py-3"
                    style={{
                      height: "4rem",
                      verticalAlign: "middle",
                    }}
                  >
                    <td colSpan={visibleColumns.length}>
                      {renderRowSubComponent(row)}
                    </td>
                  </tr>
                )}
              </Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="d-flex justify-content-between">
        <div>
          Showing {rows.length > 0 ? pageIndex * pageSize + 1 : 0} to{" "}
          {rows.length > 10 ? (pageIndex + 1) * 10 : rows.length} of{" "}
          {rows.length} entries
        </div>
        <div className="d-flex" style={{ gap: "15px" }}>
          <button
            className="pagination-btn"
            onClick={previousPage}
            disabled={!canPreviousPage}
          >
            <ArrowRight
              style={{ transform: "rotate(180deg)", marginTop: "5%" }}
            />{" "}
            Prev
          </button>
          <div style={{ display: "flex", gap: "15px" }}>
            {pageList.slice(pageIndex, pageIndex + 3).map((number) => {
              return (
                <strong
                  onClick={(e) => {
                    gotoPage(number - 1);
                  }}
                  style={{ cursor: "pointer" }}
                  className={`number-pagination${
                    pageIndex + 1 === number && "-selected"
                  }`}
                  key={number - 1}
                >
                  {number}
                </strong>
              );
            })}
          </div>
          <button
            className="pagination-btn"
            onClick={nextPage}
            disabled={!canNextPage}
          >
            Next <ArrowRight style={{ marginTop: "5%" }} />
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default TableContainer;
